// 无人机模式
export default {
    'UM1': '起飞模式未飞行',
    'UM2': '执行起飞失败',
    'UM3': '暂停起飞',
    'UM4': '起飞中',
    'UM5': '起飞完成',
    'UM6': '降落模式未飞行',
    'UM7': '执行降落失败',
    'UM8': '暂停降落',
    'UM9': '降落中',
    'UM10': '紧急状态降落中',
    'UM11': '降落完成',
    'UM12': '执行返航失败',
    'UM13': '暂停返航',
    'UM14': '返航降落中',
    'UM15': '返航中',
    'UM16': '返航到起飞点',
    'UM17': '返航完成',
    'UM18': '执行原路返航失败',
    'UM19': '暂停原路返航',
    'UM20': '原路返航降落中',
    'UM21': '原路返航中',
    'UM22': '原路返航到起飞点',
    'UM23': '原路返航完成',
    'UM24': '执行归航失败',
    'UM25': '暂停归航',
    'UM26': '归航降落中',
    'UM27': '归航中',
    'UM28': '飞到归航点',
    'UM29': '归航完成',
    'UM30': '指点未飞行',
    'UM31': '执行指点飞行失败',
    'UM32': '暂停指点飞行',
    'UM33': '指点飞行起飞中',
    'UM34': '指点飞行降落中',
    'UM35': '指点飞行中',
    'UM36': '悬停过程',
    'UM37': '飞到指定点',
    'UM38': '执行预设动作',
    'UM39': '指点飞行完成',
    'UM40': '环绕未飞行',
    'UM41': '执行环绕飞行失败',
    'UM42': '暂停环绕飞行',
    'UM43': '环绕飞行起飞中',
    'UM44': '环绕飞行降落中',
    'UM45': '环绕飞行中',
    'UM46': '悬停过程',
    'UM47': '飞到环绕点',
    'UM48': '执行预设动作',
    'UM49': '环绕飞行完成',
    'UM50': '增稳模式未飞行',
    'UM51': '解锁增稳模式失败',
    'UM52': '增稳模式遥控器控制',
    'UM53': '定高模式未飞行',
    'UM54': '解锁定高模式失败',
    'UM55': '定高模式遥控器控制',
    'UM56': '定点模式未飞行',
    'UM57': '定点模式失败',
    'UM58': '定点模式遥控器控制',
    'UM59': '定点悬停',
    'UM60': '自动航线未飞行',
    'UM61': '执行自动航线失败',
    'UM62': '暂停自动航线',
    'UM63': '自动航线起飞中',
    'UM64': '自动航线降落中',
    'UM65': '自动航线中',
    'UM66': '悬停过程',
    'UM67': '飞到航点',
    'UM68': '执行预设动作',
    'UM69': '自动航线完成',
    'UM70': '执行AB点航线未飞行',
    'UM71': '执行AB点航线失败',
    'UM72': '暂停AB点航线航线',
    'UM73': 'AB点航线:A->B',
    'UM74': 'AB点航线:B->B',
    'UM75': 'AB点航线:B->A',
    'UM76': 'AB点航线:A->A',
    'UM77': 'AB点航线变更',
    'UM78': 'AB点航线手动避障',
    'UM79': 'AB点航线执行断点',
    'default': '未知'
}